import { LoginPage } from "./features/auth";
import "./index.css";

export function App() {
  return <LoginPage />;
}

export default App;
